// Правила свёртки строк 2 уровня в значение 1 уровня (сводка).
// Используется и в редакторе шаблона, и в реестре.

export const RULES = [
  { key: "none", label: "Не показывать", applies: "any" },
  { key: "sum", label: "Сумма", applies: "number" },
  { key: "min", label: "Минимум", applies: "number" },
  { key: "max", label: "Максимум", applies: "number" },
  { key: "avg", label: "Среднее", applies: "number" },
  { key: "same", label: "Одинаковое / иначе «Разные»", applies: "text" },
  { key: "join", label: "Перечислить уникальные", applies: "text" },
  { key: "count", label: "Количество строк", applies: "any" }
];

// Ключ, под которым значение столбца лежит в строке (item).
export const itemKey = (column) => column.key || column.id;

export const getItemValue = (item, column) => {
  if (!item) return "";
  const value = item[itemKey(column)];
  return value === undefined || value === null ? "" : value;
};

const isNumberColumn = (column) =>
  column.key === "amount" || column.format === "number";

// Какие правила доступны для столбца с учётом его типа.
export const availableRules = (column) =>
  RULES.filter((rule) =>
    rule.applies === "any" ||
    (rule.applies === "number" ? isNumberColumn(column) : !isNumberColumn(column))
  );

export const defaultRuleFor = (column) => (isNumberColumn(column) ? "sum" : "same");

const toNumber = (value) => {
  const n = Number(String(value).replace(",", ".").trim());
  return Number.isNaN(n) ? null : n;
};

// Вычисляет значение 1 уровня для столбца по строкам.
// Возвращает { value, isNumber } или null, если правило "none".
export function computeSummary(column, rule, items = []) {
  const effectiveRule = rule || defaultRuleFor(column);

  if (effectiveRule === "none") {
    return null;
  }

  if (effectiveRule === "count") {
    return { value: items.length, isNumber: true };
  }

  const raw = items.map((item) => getItemValue(item, column));

  if (["sum", "min", "max", "avg"].includes(effectiveRule)) {
    const numbers = raw.map(toNumber).filter((n) => n !== null);

    if (numbers.length === 0) {
      return { value: 0, isNumber: true };
    }

    let value;
    if (effectiveRule === "sum") value = numbers.reduce((a, b) => a + b, 0);
    else if (effectiveRule === "min") value = Math.min(...numbers);
    else if (effectiveRule === "max") value = Math.max(...numbers);
    else value = numbers.reduce((a, b) => a + b, 0) / numbers.length;

    return { value, isNumber: true };
  }

  // Текстовые правила: работаем по непустым уникальным значениям.
  const unique = [...new Set(
    raw.map((v) => String(v).trim()).filter(Boolean)
  )];

  if (effectiveRule === "join") {
    return { value: unique.join(", "), isNumber: false };
  }

  // "same": одно уникальное значение — показываем его, иначе «Разные».
  if (unique.length === 0) return { value: "", isNumber: false };
  if (unique.length === 1) return { value: unique[0], isNumber: false };
  return { value: "Разные", isNumber: false };
}
